/**
 * CardAction4 시나리오
 * 사용자 자동 맞춤 - action4.svg
 */

import { ReactComponent as Action4SVG } from "@/assets/animations/action4.svg";
import type { MotionScenario } from "../types";

export const cardAction4Scenario: MotionScenario = {
  svgComponent: Action4SVG,

  transitionSpeed: 1500,

  repeat: {
    mode: "once",
  },

  viewBoxAnimation: {
    duration: 800,
    easing: "easeInOut",
  },

  scenes: [
    // Scene 1: DxSearch
    {
      id: 1,
      name: "DxSearch",
      elements: [
        {
          selector: 'g[data-name="DxSearch"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="EncounterDx"]',
          opacity: 0,
        },
        {
          selector: 'g[data-name="Highlight"]',
          opacity: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="DxSearch"]',
        zoom: 0.4,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="DxSearch"]',
    },

    // Scene 2: EncounterDx 추가
    {
      id: 2,
      name: "EncounterDx",
      elements: [
        {
          selector: 'g[data-name="DxSearch"]',
          opacity: 1, // 유지
        },
        {
          selector: 'g[data-name="EncounterDx"]',
          opacity: 1,
        },
        {
          selector: 'g[data-name="Highlight"]',
          opacity: 0,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="EncounterDx"]',
        zoom: 0.5,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="EncounterDx"]',
    },

    // Scene 3: Highlight 추가 (줌 유지)
    {
      id: 3,
      name: "Highlight",
      elements: [
        {
          selector: 'g[data-name="DxSearch"]',
          opacity: 1, // 유지
        },
        {
          selector: 'g[data-name="EncounterDx"]',
          opacity: 1, // 유지
        },
        {
          selector: 'g[data-name="Highlight"]',
          opacity: 1,
        },
      ],
      viewBox: {
        centerSelector: 'g[data-name="EncounterDx"]',
        zoom: 0.5,
      },
      glowEffect: true,
      glowSelector: 'g[data-name="Highlight"]',
    },
  ],
};
